<div class="modal-material" data-cy="modal-material">
  @if (selectedMaterial == null) {
    <div class="modal-header">
      <p class="modal-title">Add Material</p>
      <button (click)="activeModal.dismiss()" class="close" type="button"></button>
    </div>
  }
  @if (selectedMaterial != null) {
    <div class="modal-header">
      <p class="modal-title">Edit</p>
      <button (click)="activeModal.dismiss()" class="close" type="button"></button>
    </div>
  }

  <div class="modal-body">
    @if (showBoxOrderQuantityInfo) {
      <app-warning-box
        [warningLevel]="warningBoxLevel"
        class="material-position-warning-box-order-quantity"
        data-cy="material-position-modal-warning-box-message-moq">Material has Minimum Order Quantity (MOQ)
        of {{minimumQuantity}}.
      </app-warning-box>
    }
    <div class="grid-container">
      <div [ngClass]="{'grid-item': true, 'material': true, 'reduce-padding': reduceMaterialPadding}"
        data-cy="material-list-modal-material-container">
        <app-input-autocomplete #material
          (inputStateChange)="materialStateChange($event)"
          (inputValueChange)="materialChange($event)"
          [hasInactiveOptions]="true"
          [inputFormatter]="typeahead.inputTextNumberDescriptionFormatter"
          [messageInactive]="MESSAGE_INACTIVE_MATERIAL"
          [messages]="materialMessages"
          [resultFormatter]="typeahead.inputTextNumberDescriptionFormatter"
          [resultsFunction]="searchMaterials"
          [validators]="validators.material"
          [warningLevel]="WarningsEnum.WARNING"
          [dropdownDisabled]="state.isLoading"
          baseCypressTag="material-list-modal-material"
          label="Material"
        placeholder="Search for material"></app-input-autocomplete>
      </div>
      <div [ngClass]="{'grid-item': true, 'reduce-padding': reduceOrderedQuantityPadding}">
        <app-input-units #orderedQuantity
          (inputStateChange)="orderQuantityStateChange($event)"
          (inputValueChange)="orderQuantityChange($event)"
          [messages]="orderedQuantityMessages"
          [placeholder]=getOrderQuantityPlaceholder()
          [units]="units"
          [validators]="validators.orderedQuantity"
          [warningLevel]="WarningsEnum.INFO"
          baseCypressTag="material-list-modal-orderedQuantity"
          label="Order quantity"
        maxLength="6"></app-input-units>
      </div>
      <div class="grid-item">
        <app-input-text #modelType
          isToUpperCaseInputTextValue="true"
          (inputStateChange)="modelTypeStateChange($event)"
          (inputValueChange)="modelTypeChange($event)"
          [messages]="modelTypeMessages"
          [validators]="validators.modelType"
          baseCypressTag="material-list-modal-modelType"
          label="Model type"
          maxLength="4"
        placeholder="e.g. AA00"></app-input-text>
      </div>
      <div class="grid-item">
        <app-input-text #lotNumber
          (inputStateChange)="lotNumberStateChange($event)"
          (inputValueChange)="lotNumberChange($event)"
          [messages]="lotNumberMessages"
          [validators]="validators.lotNumber"
          baseCypressTag="material-list-modal-lotNumber"
          label="LOT number"
          maxLength="4"
        placeholder="e.g. 0000"></app-input-text>
      </div>
      <div class="grid-item">
        <app-input-text #mcdrNumber
          (inputStateChange)="mcdrNumberStateChange($event)"
          (inputValueChange)="mcdrNumberChange($event)"
          [messages]="mcdrNumberMessages"
          [validators]="validators.mcdrNumber"
          baseCypressTag="material-list-modal-mcdrNumber"
          label="MCDR number"
          maxLength="9"
        placeholder="e.g. 000000000"></app-input-text>
      </div>
      <div class="grid-item">
        <app-input-text #igefNumber
          isToUpperCaseInputTextValue="true"
          (inputStateChange)="igefNumberStateChange($event)"
          (inputValueChange)="igefNumberChange($event)"
          [messages]="igefNumberMessages"
          [validators]="validators.igefNumber"
          baseCypressTag="material-list-modal-igefNumber"
          label="IGEF number"
          maxLength="8"
        placeholder="e.g. 9504N408"></app-input-text>
      </div>
      <div class="grid-item">
        <app-input-text #colourCode
          isToUpperCaseInputTextValue="true"
          (inputStateChange)="colourCodeStateChange($event)"
          (inputValueChange)="colourCodeChange($event)"
          [messages]="colourCodeMessages"
          [validators]="validators.colourCode"
          baseCypressTag="material-list-modal-colourCode"
          label="Colour code"
          maxLength="4"
        placeholder="e.g. WC4L"></app-input-text>
      </div>
    </div>

    <div class="modal-footer">
      <button (click)="activeModal.close()"
        class="btn-text-link discardButton"
        data-cy="material-list-modal-button-discard"
        type="button">
        <span class="text">Discard</span>
      </button>
      @if (selectedMaterial) {
        <button (click)="add()"
          [disabled]="disableAddButtons()"
          class="btn-primary addButton"
          data-cy="material-list-modal-button-edit"
          type="button">Edit
        </button>
      } @else {
        <button (click)="addAndNew()"
          [disabled]="disabledAddAndNew()"
          class="btn-secondary addAndNewButton"
          data-cy="material-list-modal-button-addAndNew"
          type="button">Add and New
        </button>
        <button (click)="add()"
          [disabled]="disabledAdd()"
          class="btn-primary addButton"
          data-cy="material-list-modal-button-add"
          type="button">Add
        </button>
      }


    </div>
  </div>

  <ng-template #dropdownButtonTemplate>
    <button type="button"
      data-cy="dropdown-button"
      class="btn-text-link view-more"
      data-cy="dropdown-button"
      [disabled]="disabledViewMore()"
      (click)="dropdownButtonClick($event)">
      @if (state.isLoading) {
        <app-loading-spinner class="button-spinner overlap"
          data-cy="view-more-loading-spinner"
          >
        </app-loading-spinner>
      }
      <app-tooltip [dynamic]="false"
        [disable]="hasMoreMaterialsToReturn()"
        [message]="MESSAGE_VIEW_MORE">
        <span data-cy="dropdown-button-label">View more...</span>
      </app-tooltip>
    </button>
  </ng-template>
